module.exports = __webpack_public_path__ + "static/media/services.2e20b4e4.jpg";